import { AccessStatus } from '@confluence/session-data/entry-points/SiteInformationQuery.ts';
import { SYSTEM_HEADER_LEFT } from '@confluence/web-item-location/entry-points/webFragmentLocations.ts';
import { FORGE_MODULE_GLOBAL_PAGE } from '@confluence/forge-ui/entry-points/ForgeModuleType.ts';
import type { ForgeModules } from '@confluence/forge-ui/entry-points/ForgeModules.ts';

import { AUTOMATION_KEY, DISCOVER_KEY, PEOPLE_KEY, SPACES_KEY } from './appKeys.tsx';

export const NOT_ALLOWED_WEB_ITEMS: string[] = [SPACES_KEY, PEOPLE_KEY, DISCOVER_KEY];

type GlobalAppsParams = {
	webItemParams: Record<'location', string> & {
		notAllowedWebItems: string[];
	};
	forgeExtensionParams: {
		moduleType: ForgeModules;
		spaceKey: string;
	};
};

export const getGlobalAppsParams = ({
	edition,
	accessStatus,
}: {
	edition: any;
	accessStatus: any;
}): GlobalAppsParams => {
	const isAdmin = accessStatus === AccessStatus.LICENSED_ADMIN_ACCESS;
	const hideAutomation = edition !== 'PREMIUM' || !isAdmin;

	const notAllowedWebItems = [...NOT_ALLOWED_WEB_ITEMS, hideAutomation ? AUTOMATION_KEY : ''];

	return {
		webItemParams: {
			location: SYSTEM_HEADER_LEFT,
			notAllowedWebItems,
		},
		forgeExtensionParams: {
			moduleType: FORGE_MODULE_GLOBAL_PAGE,
			spaceKey: '',
		},
	};
};
